import template from './index.html.twig';
import './index.scss';

Shopware.Component.register('sw-cms-block-moorl-grid-layout-thirteen', {
    template,
});
